import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { useMemo } from 'react';

function SortableItem({ itemTemplate, item, index, disabled }) {
  const { attributes, listeners, setNodeRef, transform, transition, active } = useSortable({
    id: item?.id,
    disabled,
  });

  const cursor = useMemo(() => {
    if (disabled) {
      return 'default';
    }

    return active ? 'grabbing' : 'grab';
  }, [disabled, active]);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor,
  };

  return (
    <tr
      key={item?.id}
      ref={setNodeRef}
      style={{ ...style, touchAction: 'none' }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...attributes}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...listeners}
    >
      {itemTemplate(item, index)}
    </tr>
  );
}

export default React.memo(SortableItem);

SortableItem.propTypes = {
  index: PropTypes.number.isRequired,
  itemTemplate: PropTypes.func.isRequired,
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
};

SortableItem.defaultProps = {
  disabled: false,
};
